module.exports = __webpack_public_path__ + "static/media/octes8h_6.f89d5871.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_6.svg
// module id = 751
// module chunks = 0